import React from "react";

import { SupportedData } from "../../../utils/data-utils";
import { GenericValue } from "./generic-value";

export function CellGenericValue<T extends object>({
  item,
  attr,
  variableDef,
}: {
  item: T;
  attr: keyof T;
  variableDef: SupportedData | undefined;
}) {
  return <GenericValue value={item[attr]} variableDef={variableDef} />;
}
